import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Modal } from "antd"

import * as Template from "../../templates";
import * as actions from "../../actions";
import { websiteBaseUrl } from "../../libraries/helper";
import { useLocation } from "react-router-dom";

export default () => {
  
  const moduleName = "users";
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const [lgShow, setLgShow] = useState(false);
  const [lgEditShow, setLgEditShow] = useState(false);
  const location = useLocation()
  const [userAddresses, setUserAddresses] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const [rows, setRows] = useState([])

  const [provinceId, setProvinceId] = useState()
  const [cityId, setCityId] = useState([])

  const [editAddress, setEditAddress] = useState([])
  const [provinces, setProvinces] = useState([])
  const [roleOptions, setRoleOptions] = useState([])
  const [cities, setCities] = useState([])
  const [role, setRole] = useState(``);

  const handleDelete = (id) => dispatch(actions.destroy(id, moduleName));
  const handleChangeRole = (value) => setRole(value)

  const changeModal = (status, row) => {
    setLgShow(status);
    setUserAddresses(row.user_addresses)
  };

  const handleChangeProvince = (id) => {
    setProvinceId(id)
    setCityId(undefined)
    dispatch(actions.list(`cities/option`, `?province_id=${id.value}`));
  }

  const handleChangeCity = (item) => setCityId(item)

  const changeModalEdit = (status, row) => {
    changeModal(false, row)
    setEditAddress(row)
    setLgEditShow(status);
  };

  const handleClick = () => dispatch(actions.update(editAddress.id, "users/addresses"))

  useEffect(() => {
    dispatch(actions.list(`provinces/option`));
    dispatch(actions.list(`roles/option`));
  }, [])

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
    setLgEditShow(false);
  }, [
    appReducer.users_destroy,
    appReducer.users_addresses_update,
    appReducer.users_active,
    appReducer.users_deactive,
    location.search
  ]);

  useEffect(() => {
    if (appReducer.roles_option_list != undefined) {
      setRoleOptions(appReducer.roles_option_list.data)
    }
  })

  useEffect(() => {
    if (appReducer.users_list != undefined) {
      setRows(appReducer.users_list.data)
      setTotalPages(appReducer.users_list.count)
    }
  }, [appReducer])


  useEffect(() => {
    if (appReducer.provinces_option_list != undefined) {
      setProvinces(appReducer.provinces_option_list.data)
    }
  }, [appReducer.provinces_option_list])

  useEffect(() => {
    if (appReducer.cities_option_list != undefined) {
      setCities(appReducer.cities_option_list.data)
    }
  }, [appReducer.cities_option_list])


  useEffect(() => {
    if (editAddress.city != undefined) {
      setProvinceId({
        label: editAddress.city.province.name,
        value: editAddress.city.province.id,
      })
      setCityId({
        label: editAddress.city.name,
        value: editAddress.city.id,
      })
    }
  }, [editAddress])


  const addressItemsColumns = [
    {
      name: 'تحویل‌گیرنده',
      selector: row => row.info,
    },
    {
      name: 'موبایل',
      selector: row => row.mobile,
    },
    {
      name: 'تلفن ثابت',
      selector: row => row.tell,
    },
    {
      name: 'شهر',
      selector: row => row.city ? row.city.name : "",
    },
    {
      name: 'استان',
      selector: row => row.city ? row.city.province.name : "",
    },
    {
      name: 'کد پستی',
      selector: row => row.zipcode,
    },
    {
      name: 'عملیات',
      selector: row => <div className="py-3"><Template.Button
        onClick={() => changeModalEdit(true, row)}
        label="ویرایش"
        background="bg-black text-white text-xs"
      /></div>,
    }
  ]


  const columns = [
    {
      name: 'موبایل',
      selector: row => row.mobile,
    },
    {
      name: 'امتیاز باشگاه',
      selector: row => row.rate,
    },
    {
      name: 'نقش',
      selector: row => {
        let roles = [];
        if (row.role_users.length > 0) {
          roles = row.role_users.map(role => {
            return role.role.name
          })
        }
        return roles.length > 0 ? roles.join(" , ") : "-"
      },
    },
    {
      name: 'نام',
      selector: row => row.first_name ? row.first_name : '-',
    },
    {
      name: 'نام خانوادگی',
      selector: row => row.last_name ? row.last_name : '-',
    },
    {
      name: 'فروشگاه',
      selector: row => row.business != null ? row.business.name : '-',
    },
    {
      name: 'وضعیت',
      selector: row => <Template.State variant={row.state} />,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: "عملیات",
      width: "350px",
      selector: row => <div className="flex items-center gap-2 my-4">
        <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />
        {row.user_addresses.length > 0 && <Template.Button
          onClick={() => changeModal(true, row)}
          label="آدرس‌ها"
          background="bg-gradient-to-tr from-indigo-300 to-indigo-400 text-xs"
        />}
        <a target="new" href={`${websiteBaseUrl}/user/manual-login/${row.id}`} className="bg-gradient-to-tr from-teal-300 to-teal-400 hover:opacity-75 border text-xs  font-bold  px-3 py-3 flex justify-center items-center rounded-md text-gray-700 ">ورود به سایت</a>
      </div>
    }
  ];

  return <div>

    <Modal
      title="ویرایش آدرس"
      open={lgEditShow}
      footer={[<div></div>]}
      centered
      onCancel={() => changeModalEdit(false, 0)}
    >
      <Template.Form>
        <Template.Input value={editAddress.name} label="نام" name="name" type="text" />
        <Template.Input value={editAddress.lastname} label="نام خانوادگی" name="lastname" type="text" />
        <Template.Input value={editAddress.identity} label="کد ملی" name="identity" type="text" />
        <Template.Input value={editAddress.address} label="آدرس پستی" name="address" type="text" />
        <Template.Input value={editAddress.tell} label="تلفن ثابت" name="tell" type="text" />
        <Template.Input value={editAddress.mobile} label="موبایل" name="mobile" type="text" />
        <Template.Input value={editAddress.zipcode} label="کد پستی" name="zipcode" type="text" />
        <Template.SingleSelect
          placeholder="انتخاب استان"
          withLabel={true}
          name="province_id"
          value={provinceId}
          onChange={handleChangeProvince}
          options={provinces}
        />
        <Template.SingleSelect
          placeholder="انتخاب شهر"
          withLabel={true}
          onChange={handleChangeCity}
          value={cityId}
          name="city_id"
          options={cities}
        />
        <Template.Button
          label="ذخیره"
          background="bg-gradient-to-tr from-green-300 to-green-400"
          onClick={handleClick}
        />
      </Template.Form>
    </Modal>


    <Modal
      title="مشاهده آدرس‌ها"
      open={lgShow}
      width={1000}
      footer={[<div></div>]}
      centered
      onCancel={() => changeModal(false, 0)}
    >
      <Template.Table columns={addressItemsColumns} data={userAddresses} />
    </Modal>

    <Template.Filter moduleName={moduleName} >

      <Template.Input label="موبایل" name="mobile" type="text" />

      <Template.Input label="نام" name="first_name" type="text" />

      <Template.Input label="نام خانوادگی" name="last_name" type="text" />

      <Template.SingleSelect
        withLabel
        placeholder="نقش کاربری"
        name="role"
        onChange={handleChangeRole}
        value={role}
        options={roleOptions}
      />

    </Template.Filter>

    <Template.Table count={totalPages} columns={columns} data={rows} />
  </div>;

};